var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6387 12.1453C20.6969 10.5174 19.3427 9.15194 17.7224 8.19678C16.0528 7.2126 14.1404 6.69238 12.1919 6.69238C10.2434 6.69238 8.33094 7.2126 6.66139 8.19678C5.04109 9.15198 3.68685 10.5174 2.74508 12.1453C2.67417 12.268 2.67417 12.4191 2.74508 12.5418C3.68685 14.1697 5.04109 15.5352 6.66139 16.4903C8.33098 17.4745 10.2434 17.9947 12.1919 17.9947C14.1404 17.9947 16.0528 17.4745 17.7224 16.4903C19.3427 15.5351 20.6969 14.1697 21.6387 12.5418C21.7096 12.4191 21.7096 12.268 21.6387 12.1453ZM17.3203 15.8083C15.7724 16.7207 13.9991 17.203 12.1919 17.203C10.3846 17.203 8.61123 16.7207 7.06341 15.8083C5.62652 14.9612 4.41515 13.7664 3.54804 12.3435C4.41515 10.9206 5.62652 9.72578 7.06341 8.87873C8.61123 7.9663 10.3846 7.484 12.1919 7.484C13.9991 7.484 15.7724 7.9663 17.3203 8.87873C18.7572 9.72578 19.9685 10.9205 20.8357 12.3435C19.9685 13.7664 18.7572 14.9612 17.3203 15.8083Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1916 8.78613C10.2303 8.78613 8.63477 10.3817 8.63477 12.343C8.63477 14.3043 10.2303 15.8999 12.1916 15.8999C14.1529 15.8999 15.7485 14.3043 15.7485 12.343C15.7485 10.3817 14.1529 8.78613 12.1916 8.78613ZM12.1916 15.1082C10.6669 15.1082 9.42642 13.8678 9.42642 12.343C9.42642 10.8183 10.6669 9.57779 12.1916 9.57779C13.7164 9.57779 14.9569 10.8183 14.9569 12.343C14.9569 13.8678 13.7164 15.1082 12.1916 15.1082Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpened);
export default __webpack_public_path__ + "static/media/eye-opened.66cad17c3e0c4e3a9b1a5a7871f08fa7.svg";
export { ForwardRef as ReactComponent };